module.exports = __webpack_public_path__ + "img/bakir-hero.798a195c.png";